import React, { useState } from 'react'
import UserContext from './UserContext'
const UserContextProvider=({children})=>{
    const [selectedFolder, setSelectedFolder] = useState("Procedures");
    console.log("🚀 ~ UserContextProvider ~ selectedFolder:", selectedFolder)
    const [folderId, setFolderId] = useState();
    console.log("🚀 ~ UserContextProvider ~ folderId:", folderId)
    const [fileId, setFileId] = useState("");
    console.log("🚀 ~ UserContextProvider ~ fileId:", fileId)
    const [selectedFolder1, setSelectedFolder1] = useState("");
    console.log("🚀 ~ UserContextProvider ~ selectedFolder1:", selectedFolder1)

    return(
        <UserContext.Provider value={{selectedFolder1, setSelectedFolder1,fileId, setFileId,selectedFolder,setSelectedFolder,folderId,setFolderId}}>
            {children}
        </UserContext.Provider>
    )

}
export default UserContextProvider